import { create } from "zustand";
import Cookies from "js-cookie";
import { TOKEN_COOKIE_CONFIG } from "../../config";

const useAuth = create((set) => ({
  accessToken: Cookies.get("accessToken"),
  refreshToken: Cookies.get("refreshToken"),
  userId: Cookies.get("userId"),
  isAuthenticated: !!Cookies.get("accessToken"),
  userRole: Cookies.get("userRole"),

  setTokens: (accessToken, refreshToken, userId) => {
    Cookies.set("accessToken", accessToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("refreshToken", refreshToken, TOKEN_COOKIE_CONFIG);
    Cookies.set("userId", userId, TOKEN_COOKIE_CONFIG);
    set({
      accessToken,
      refreshToken,
      userId,
      isAuthenticated: true,
    });
  },

  setUserRole: (role) => {
    Cookies.set("userRole", role, TOKEN_COOKIE_CONFIG);
    set({ userRole: role });
  },

  clearTokens: () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    Cookies.remove("userId");
    Cookies.remove("userRole");
    set({
      accessToken: null,
      refreshToken: null,
      userId: null,
      isAuthenticated: false,
      userRole: null,
    });
  },

  updateAccessToken: (newAccessToken) => {
    Cookies.set("accessToken", newAccessToken, TOKEN_COOKIE_CONFIG);
    set({
      accessToken: newAccessToken,
    });
  },
}));

export default useAuth;
